export default class FormSubmissionService {
  constructor({ host, accountId }) {
    this.host = host
    this.accountId = accountId
  }

  submitForm(params, callback) {
    let url = `${this.host}/accounts/${this.accountId}/submit-form`

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }
        return response.json()
      })
      .then(() => callback())
      .catch((error) => console.error('Form submission failed:', error))
  }
}
